import React, { Component } from 'react';
import _ from 'lodash';

import ShowDocument from '../../components/documents/ShowDocument';
import DocumentTemplateStore from '../../stores/DocumentTemplateStore';

export default class ShowDocumentPage extends Component {

	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			document_id: this.props.match.params.id,
			template_id: this.props.match.params.template_id,
			workflow_process_id: this.props.match.params.workflow_process_id,
			document_template: {}
		}
	}

	render(){
		return (
			<div>
				<ShowDocument
					document_id={this.props.match.params.id}
					workflow_process_id={this.state.workflow_process_id}
					{...this.props} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/documents/ShowDocumentPage.js